// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2AWnN","footer":"ReportModalFilter_footer__2SqXz"};